import { render, staticRenderFns } from "./VasDetailsStandard.vue?vue&type=template&id=2faf7d4b&scoped=true&"
import script from "./VasDetailsStandard.vue?vue&type=script&lang=ts&"
export * from "./VasDetailsStandard.vue?vue&type=script&lang=ts&"
import style0 from "./VasDetailsStandard.vue?vue&type=style&index=0&id=2faf7d4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faf7d4b",
  null
  
)

export default component.exports